import React, { useState } from "react";
import ParagraphTag from "../reusebale/Paragraph";
import LabelTag from "../reusebale/label";
import ButtonTag from '../reusebale/button';

const MaintenanceFilterPopUp = ({ onFilter, onBack, closePopup }) => {
  const FilterList = [
    { id: 1, name: "All", value: "All" },
    { id: 2, name: "Active", value: "active" },
    { id: 3, name: "Parts Ordered", value: "Parts Ordered" },
    { id: 4, name: "In Progress", value: "In Progress" },
    { id: 4, name: "Completed", value: "Completed" },
  ]

  const [status, setStatus] = useState("All")

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[18%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 lg:py-5 rounded-xl justify-center items-center flex flex-col">
          <div>
            <ParagraphTag
              content="Filter"
              classes={`text-darkColor font-popinsSemiBold text-sm `}
            />
          </div>
          <div className="w-full px-2 mt-2">
            <LabelTag isStaric={false} name="Status" />
            <select
              value={status}
              onChange={(e) => {
                setStatus(e.target.value)
                // closePopup()
              }}
              className="w-full mt-2 bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor/40 placeholder:text-zinc-700/50 font-popinsRegular"
            >
              {
                FilterList.map((i) => (
                  <option key={i.value} value={i.value}>{i.name}</option>
                ))
              }
            </select>
          </div>


          <div className="w-full px-2">
            <ButtonTag onSubmit={() => {
              onFilter(status)
            }} name='Filter' classes='text-sm bg-themeColor hover:bg-themeColor/90 mt-5 text-center  text-white' />
            <p className="text-darkColor pt-2 flex item-center justify-center cursor-pointer font-popinsMedium text-sm" onClick={onBack}>Close</p>
          </div>

        </div>
      </section>
    </main>
  );
};

export default MaintenanceFilterPopUp;
